import { useAuth } from '../../services/auth/AuthContext';
import Typography from '@mui/material/Typography';
import { Box, Paper,Button} from '@mui/material';

import { SharedCard } from '../../components/shared-card/card';
import Navbar from '../../components/shared-menu/Navbar';
import DashboardHome from './components/dashboard/home';
import { useTranslation } from 'react-i18next';

export default function Dashboard(props) {
  const { t } = useTranslation();
const { user } = useAuth();
  const userStatus = user?.user_profile.onboarding_status;

  return (
      <Box display={'flex'} flexDirection={'column'} height={'100vh'}>
        <Navbar />
        {userStatus === "approved" ? (
          <DashboardHome userProfile={user.user_profile} />
        ) : (
          <SharedCard>
            <Typography variant="h4" gutterBottom>
              {t('awaiting_approval.header')}
            </Typography>
            <Typography variant="h6" gutterBottom>
              {t('awaiting_approval.para1')}
            </Typography>
            <Typography variant="h6" gutterBottom>
              {t('awaiting_approval.para2')}
            </Typography>
          </SharedCard>
        )}
      </Box>
  );
}